import React, { useEffect, useState, useContext } from "react";

import { Card, CardHeader, Icon } from "@mui/material";
// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import MDBox from "components/MDBox";
import MDInput from "components/MDInput";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import AsyncSelect from "react-select/async";
import CreateDomesticStayReq from "../../../Classes/Models/Requests/Accounting/CreateDomesticStayReq";
import AccountingApi from "../../../Classes/API/AccountingApi";
import Swal from "sweetalert2";
import searchUsersReq from "../../../Classes/Models/Requests/Users/SearchUser";
import UsersApi from "../../../Classes/API/UsersApi";
import UserTypes from "../../../Classes/Models/Requests/Users/UserTypes";
import { LanguageContext } from "App";
import { useNavigate } from "react-router-dom";
import { use } from "react";
import input from "assets/theme/components/form/input";

const index = () => {
  const navigate = useNavigate();
  const [PatientsSearch, setPatientsSearch] = useState();
  const [Patient, setPatient] = useState({});
  const { translations } = useContext(LanguageContext);
  const [StartDate, setStartDate] = useState(new Date());
  const [NumberOfDays, setNumberOfDays] = useState(0);
  const [RoomId, setRoomId] = useState("");
  const [RoomType, setRoomType] = useState("");
  const [Price, setPrice] = useState(0);
  const [OverHeadPrice, setOverHeadPrice] = useState(0);
  const [InsurancePrice, setInsurancePrice] = useState(0);
  const [Notes, setNotes] = useState("");

  const [OptionPatient, setOptionPatient] = useState([]);

  useEffect(() => {
    GetPatients().then((res) => {
      setOptionPatient(res);
    });
  }, []);
  const GetPatients = async (inputValue = "") => {
    let searchReq = new searchUsersReq();
    let UserTypes1 = new UserTypes();

    searchReq.name = inputValue;
    searchReq.userType = UserTypes1.Patient;
    let res = await UsersApi.SearchUsers(searchReq);

    if (res.status == "Success") {
      let optionsArr = res.data.list.map((item) => ({
        value: item,
        label: item.name,
      }));
      if (inputValue) {
        optionsArr = optionsArr.filter((item) =>
          item.label.toLowerCase().includes(inputValue.toLowerCase())
        );
      }
      return optionsArr;
    }
    return [];
  };

  const onCreateClick = async () => {
    let req = new CreateDomesticStayReq();

    if (Object.keys(Patient).length < 1) {
      Swal.fire({
        title: "Error",
        text: "Please select a patient",
        icon: "error",
        confirmButtonText: "Ok",
      });
      return;
    }

    if (NumberOfDays < 1) {
      Swal.fire({
        title: "Error",
        text: "Please select a number of days",
        icon: "error",
        confirmButtonText: "Ok",
      });
      return;
    }

    if (Price == 0) {
      Swal.fire({
        title: "Error",
        text: "Please select a price",
        icon: "error",
        confirmButtonText: "Ok",
      });
      return;
    }

    Swal.fire({
      icon: "info",
      title: "Please wait",
      text: "Creating domestic stay",
      allowOutsideClick: false,
      showConfirmButton: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });

    req.patientId = Patient.getPatient.id;
    req.startDate = StartDate;
    req.numberOfDays = NumberOfDays;
    req.roomId = RoomId;
    req.roomType = RoomType;
    req.price = Price;
    req.insurancePrice = InsurancePrice;
    req.notes = Notes;
    req.overHeadPrice = OverHeadPrice;
    let res = await AccountingApi.CreateDomesticStay(req);
    if (res.status == "Success") {
      Swal.fire({
        title: "Success",
        text: res.message,
        icon: "success",
        confirmButtonText: "OK",
      }).then(() => {
        navigate("/domesticstays/Details", { state: { SearchStay: res.data } });
      });
    } else {
      Swal.fire({
        title: "Error",
        text: res.message,
        icon: "error",
        confirmButtonText: "OK",
      });
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <div className={translations.setlang === "ar" ? "rtl-label" : ""}>
        <Card sx={{ padding: "2em" }}>
          <MDBox pt={2} px={2} display="flex" justifyContent="space-between" alignItems="center">
            <MDTypography variant="h6" fontWeight="medium">
              {translations.CreateDomesticStay}
            </MDTypography>
            <MDButton
              onClick={() => onCreateClick()}
              sx={{ backgroundColor: "#3560AD", "&:hover": { backgroundColor: "#4682B4" } }}
              color="success"
            >
              <Icon sx={{ fontWeight: "bold" }}>add</Icon>
              &nbsp;{translations.CreateDomesticStayCreate}
            </MDButton>
          </MDBox>

          <div className="container-fluid">
            <div className="row">
              <div className="col-md-4 mt-3" style={{ position: "relative", zIndex: "12" }}>
                <AsyncSelect
                  isClearable={true}
                  placeholder={translations.CreateDomesticStaySelectPatient}
                  loadOptions={(inputValue) => GetPatients(inputValue)}
                  defaultOptions={OptionPatient}
                  onInputChange={setPatientsSearch}
                  onChange={(e) => setPatient(e ? e.value : "")}
                  // value={TypeId}
                />
              </div>

              <div className="col-md-4 mt-3">
                <MDInput
                  label={translations.CreateDomesticStaySelectStartDate}
                  onChange={(e) => setStartDate(e.target.value)}
                  type={"date"}
                  style={{ width: "100%" }}
                  InputLabelProps={{ shrink: true }}
                  fullWidth
                />
              </div>

              <div className="col-md-4 mt-3">
                <MDInput
                  onChange={(e) => setNumberOfDays(e.target.value)}
                  label={translations.CreateDomesticStayNumberofDays}
                  type="number"
                  style={{ width: "100%" }}
                  fullWidth
                />
              </div>

              <div className="col-md-4 mt-3">
                <MDInput
                  onChange={(e) => setRoomId(e.target.value)}
                  label={translations.CreateDomesticStayRoomId}
                  type="text"
                  style={{ width: "100%" }}
                  fullWidth
                />
              </div>

              <div className="col-md-4 mt-3">
                <MDInput
                  onChange={(e) => setRoomType(e.target.value)}
                  label={translations.CreateDomesticStayRoomType}
                  type="text"
                  style={{ width: "100%" }}
                  fullWidth
                />
              </div>

              <div className="col-md-4 mt-3">
                <MDInput
                  onChange={(e) => setPrice(e.target.value)}
                  label={translations.CreateDomesticStayRoomPrice}
                  type="number"
                  style={{ width: "100%" }}
                  fullWidth
                />
              </div>

              <div className="col-md-4 mt-3">
                <MDInput
                  onChange={(e) => setOverHeadPrice(e.target.value)}
                  type="number"
                  label={translations.CreateDomesticStayOverHeadPrice}
                  style={{ width: "100%" }}
                  fullWidth
                />
              </div>

              <div className="col-md-4 mt-3">
                <MDInput
                  onChange={(e) => setInsurancePrice(e.target.value)}
                  type="number"
                  label={translations.CreateDomesticStayInsurancePrice}
                  style={{ width: "100%" }}
                  fullWidth
                />
              </div>

              <div className="col-md-4 mt-3">
                <MDInput
                  onChange={(e) => setNotes(e.target.value)}
                  type="text"
                  label={translations.CreateDomesticStayNotes}
                  style={{ width: "100%" }}
                  fullWidth
                />
              </div>
            </div>
          </div>
        </Card>
      </div>
    </DashboardLayout>
  );
};

export default index;
